import {
  GetCenterDetailResponse,
  GetCetnerListResponse,
  GetPlannerDetailResponse,
  GetPlannerListResponse,
} from '@/api/type/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PartnerState {
  centerList: GetCetnerListResponse | null;
  centerDetail: Record<string, GetCenterDetailResponse>; // 아코디언으로 오더 상세 여러개 노출을 위한 key 분리
  plannerList: GetPlannerListResponse | null;
  plannerDetail: Record<string, GetPlannerDetailResponse>; // 아코디언으로 오더 상세 여러개 노출을 위한 key 분리
}

const initialState: PartnerState = {
  centerList: null,
  centerDetail: {},
  plannerList: null,
  plannerDetail: {},
};

export const partnerSlice = createSlice({
  name: 'partner',
  initialState,
  reducers: {
    setCenterList: (state, action: PayloadAction<GetCetnerListResponse>) => {
      state.centerList = action.payload;
    },
    setCenterDetail: (
      state,
      action: PayloadAction<{ id: string; data: GetCenterDetailResponse }>
    ) => {
      state.centerDetail[action.payload.id] = action.payload.data;
    },
    removeCenter: (state, action: PayloadAction<string>) => {
      if (!state.centerList) return;

      state.centerList.items = state.centerList.items.filter(
        (center) => center.id !== action.payload
      );
    },
    setPlannerList: (state, action: PayloadAction<GetPlannerListResponse>) => {
      state.plannerList = action.payload;
    },
    setPlannerDetail: (
      state,
      action: PayloadAction<{ id: string; data: GetPlannerDetailResponse }>
    ) => {
      state.plannerDetail[action.payload.id] = action.payload.data;
    },
  },
});

export const partner = partnerSlice.actions;
export default partnerSlice.reducer;
